<template>
  <div>
    <h1>Agenda Paziente</h1>
    <div>{{ $translate('patient') | capitalize }}: {{ patientName }}</div>
    <div>{{ $translate('birthdate') | capitalize }}: {{ birthdate }}</div>
    <div>{{ $translate('technician') | capitalize }}: {{ technician }}</div>
    <h1>Registro Eventi</h1>
    <!--<a>
      <b-icon icon="plus-box-outline" />
    </a>
    <a>
      <b-icon icon="minus-box-outline" />
    </a>
    <a>
      <b-icon icon="sync" />
    </a>-->
    <b-collapse :open="false" aria-controls="new">
      <template #trigger="props">
        <a>
          <b-icon icon="plus-box-outline" aria-controls="new" :aria-expanded="props.open" />
        </a>
      </template>
      <div class="notification">
        <div class="content">
          <h2>Creazione Evento</h2>
          <b-field label="Tipo attività">
            <b-select v-model="event.type" placeholder="Seleziona il tipo di evento">
              <option key="appuntamento" value="appuntamento">Appuntamento</option>
              <option key="presaMisure" value="presaMisure">Presa Misure</option>
              <option key="collaudo" value="collaudo">Collaudo</option>
              <option key="consegna" value="consegna">Consegna</option>
            </b-select>
          </b-field>
          <b-field label="Inizio appuntamento">
            <b-datetimepicker
              v-model="event.beginDateTime"
              placeholder="Clicca per selezionare l'inizio..."
              icon="calendar-today"
              locale="it-IT"
              :datetime-formatter="time => dateTimeFormatter(time)"
            />
          </b-field>
          <b-field label="Fine appuntamento">
            <b-datetimepicker
              v-model="event.endDateTime"
              placeholder="Clicca per selezionare la fine..."
              icon="calendar-today"
              locale="it-IT"
              :datetime-formatter="time => dateTimeFormatter(time)"
            />
          </b-field>
          <b-field label="Tecnico">
            <b-select v-model="event.technician" placeholder="Seleziona il tecnico">
              <option v-for="tec in technicians" :key="tec.username" :value="tec.username">{{
                `${tec.name} ${tec.surname}`
              }}</option>
            </b-select>
          </b-field>
          <b-field label="Negozio">
            <b-input v-model="event.shop" value="event.shop" disabled />
          </b-field>
          <b-field label="Sincronizza">
            <b-select v-model="event.orderId" placeholder="Seleziona un ordine">
              <option :value="null">Non sicronizzare</option>
              <option v-for="order in orders" :key="order.id" :value="order.id">{{ `${order.primaryCode}` }}</option>
            </b-select>
          </b-field>
          <b-button type="is-light" @click="clearNewEventForm()">Cancella</b-button>
          <b-button type="is-primary" @click="newEvent()">Salva</b-button>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      patient: {},
      technicians: [],
      orders: [],
      event: {
        patientId: this.id,
        shop: undefined,
        type: undefined,
        beginDateTime: new Date(),
        endDateTime: new Date(),
        technician: undefined,
      },
    }
  },
  computed: {
    patientName() {
      const name = `${this.patient.name} ${this.patient.surname}`
      const alias = `${this.patient.alias}`
      return this.patient.name || this.patient.surname ? `${name} - ${alias}` : `${alias}`
    },
    birthdate() {
      return this.patient.birthdate ? new Intl.DateTimeFormat('it-IT').format(this.patient.birthdate.toDate()) : ''
    },
    technician() {
      return this.patient.technician || ''
    },
  },
  async mounted() {
    this.id ? await this.loadData() : this.$router.push('/patients')
  },
  methods: {
    async saveNewEvent() {
      this.isLoading = true
      // chiama il metodo di creazione dell'evento
      // aggiunge l'evento alla lista
      this.clearNewEventForm()
      this.isLoading = false
    },
    clearNewEventForm() {
      this.event = {
        patientId: this.id,
        shop: undefined,
        type: undefined,
        beginDateTime: new Date(),
        endDateTime: new Date(),
        technician: undefined,
        orderId: null,
      }
    },
    dateTimeFormatter(time) {
      return new Intl.DateTimeFormat('it-IT', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }).format(time)
    },
    async loadData() {
      this.isLoading = true
      //this.event.patientId = this.id
      const patientDoc = await this.$db
        .collection('patients')
        .doc(this.id)
        .get()
      this.patient = patientDoc.data()
      //GET SHOP DATA
      const shopDoc = await this.$db
        .collection('shops')
        .doc(this.patient.shopId)
        .get()
      this.shop = shopDoc.data()
      this.event.shop = this.shop.name
      //GET TECHNICIANS
      const techniciansSnapshot = await this.$db
        .collection('usersInfo')
        .where('type', '==', 'C')
        .where('companyId', '==', this.shop.companyId)
        .where('shopsId', 'array-contains-any', ['*', this.patient.shopId])
        .get()
      this.technicians = techniciansSnapshot.docs.map(techDoc => techDoc.data())
      //GET ORDERS
      const ordersSnapshot = await this.$db
        .collection('orders')
        .where('patientId', '==', this.id)
        .get()
      this.orders = ordersSnapshot.docs.map(orderDoc => orderDoc.data())
      this.isLoading = false
    },
  },
}
</script>
